module.exports = __webpack_public_path__ + "media/images/div_lens/racial-skintones-18fe6e52226b4035574a1f56f9439641.png";